import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualDashboardPage() {
    return <MarkdownDocPage title="Dashboard" markdownUrl="/docs/user-manual/pages/dashboard.md" />;
}

